<div class="welcome-banner">
  <i class="pi pi-sparkles sparkle-decor"></i>
  <div class="welcome-banner-content">
    <div class="welcome-title">
      <h1 *ngIf="isFirstTime">Hello, <span class="name">{{ firstName }}!</span></h1>
      <h1 *ngIf="!isFirstTime">Welcome back, <span class="name">{{ firstName }} !</span></h1>
    </div>

    <div class="ai-input-container">
      <input type="text" placeholder="Ask us anything" class="ask-me-input" [(ngModel)]="message" (keyup.enter)="openChat()" />
      <div class="input-footer">
        <button class="ai-assistant-badge" (click)="openChat()">
           <i class="pi pi-sparkles"></i> Assistant
        </button>
        <button class="send-btn" (click)="openChat()">
          <i class="pi pi-send"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="welcome-banner-illustration">
    <img src="../../../assets/images/Welcomebox.png" alt="Journey illustration" onerror="this.style.display='none'">
  </div>
</div>

<app-chat-dialog #chatDialog></app-chat-dialog>
